import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import gif from '../Assets/Images/isometric-smart-factory-production.gif';

import AboutHome from '../Components/AboutHome';
import OurServices from '../Components/OurServices';
import ScrollBar from '../Components/ScrollBar';

const HeroSection = () => {
  return (
    <>
      {/* ⭐ SEO Optimization */}
      <Helmet>
        <title>Automation & Robotics Solutions for Manufacturing | HHG Industries</title>
        <meta
          name="description"
          content="HHG Industries delivers advanced automation, robotics, and custom engineering solutions for automotive, aeronautical, and manufacturing sectors. Boost efficiency with our expertise."
        />

        {/* Social Sharing Tags */}
        <meta property="og:title" content="Automation & Robotics Solutions for Manufacturing | HHG Industries" />
        <meta 
          property="og:description" 
          content="HHG Industries delivers advanced automation, robotics, and custom engineering solutions for automotive, aeronautical, and manufacturing sectors." 
        />
        <meta property="og:image" content="/title_logo.png" />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content="Automation & Robotics Solutions for Manufacturing | HHG Industries" />
        <meta 
          name="twitter:description" 
          content="HHG Industries delivers advanced automation, robotics, and custom engineering solutions for automotive, aeronautical, and manufacturing sectors."
        />
      </Helmet>

      <div className="hhg-hero-container">
        <div className="hhg-hero-inner">
          <div className="hhg-hero-text">
            <p className="hhg-hero-welcome">Welcome to HHG INDUSTRIES PRIVATE LIMITED</p>
            <h1 className="hhg-hero-heading">
              Tailored Automation<br />
              Solutions for Every Industry
            </h1>
            <p className="hhg-hero-subheading">
              Our scalable automation solutions deliver maximum ROI and ensure peak <br /> operational efficiency.
            </p>
            <div className="hhg-hero-buttons">
              <a href="/ContactUs" className="hhg-btn-yellow">Get Started</a>
              <a href="/about" className="hhg-btn-blue">Learn More</a>
            </div>
          </div>
          <div className="hhg-hero-gif">
            <img src={gif} alt="Automation Demo" className="hhg-hero-img" style={{ maxWidth: '120%' }} />
          </div>
        </div>
      </div>

      <ScrollBar />
      <AboutHome />
      <OurServices />

      <style>{`
        .hhg-hero-container {
          width: 100%;
          display: flex;
          justify-content: center;
          padding: 40px 0;
          background-color: #fff;
          margin-bottom:70px;
          margin-top:60px;
        }

        .hhg-hero-inner {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          max-width: 1429px;
          width: 100%;
          padding: 0 60px;
          border-radius: 30px;
        }

        .hhg-hero-text {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .hhg-hero-welcome {
          font-size: 20px;
          font-weight: 540;
          margin-bottom: 20px;
          color: #000000;
        }

        .hhg-hero-heading {
          font-size: 50px;
          font-weight: 350;
          margin-bottom: 20px;
          line-height: 1.2;
          color: #004E98;
        }

        .hhg-hero-subheading {
          font-size: 18px;
          margin-bottom: 40px;
          font-weight: 400;
          color: #696969;
        }

        .hhg-hero-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .hhg-btn-yellow,
        .hhg-btn-blue {
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 400;
          text-decoration: none;
          font-family: 'Kanit', sans-serif;
          font-size: 16px;
        }

        .hhg-btn-yellow {
          background-color: #FFD700;
          color: #000000;
        }

        .hhg-btn-blue {
          background-color: #003087;
          color: #ffffff;
        }

        .hhg-btn-blue:hover {
          background-color: #003087;
          color: #ffffff;
        }

        .hhg-hero-gif {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hhg-hero-img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
          border-radius: 12px;
        }

        @media (max-width: 768px) {
          .hhg-hero-inner {
            flex-direction: column;
            padding: 20px;
          }

          .hhg-hero-text {
            text-align: center;
          }

          .hhg-hero-heading {
            font-size: 32px;
          }

          .hhg-hero-subheading {
            font-size: 16px;
            line-height: 1.5;
          }

          .hhg-hero-welcome {
            font-size: 18px;
          }

          .hhg-hero-buttons {
            justify-content: center;
          }

          .hhg-hero-img {
            width: 100%;
            max-height: 300px;
          }
        }
      `}</style>
    </>
  );
};

export default HeroSection;
